module.exports = __webpack_public_path__ + "img/user-face-3.62bebfa8.jpg";